import * as React from 'react'
import clx from 'classnames'

const DividerVertical = ({ className }: { className?: string }) => {
  return (
    <div
      className={clx(
        'tw-w-0.5 tw-bg-secondary',
        className ?? 'tw-block tw-h-5',
      )}
    ></div>
  )
}

export default DividerVertical
